export const OPEN = "completeDialog/OPEN";
export const CLOSE = "completeDialog/CLOSE";
export const openCompleteDialog = dialogData => ({
  type: OPEN,
  dialogData
});
export const closeCompleteDialog = () => ({
  type: CLOSE
});

const initialState = {
  open: false,
  title: "",
  contentText: "",
  btnLabel: "",
  caution: false,
  handleOpenClick: null,
  handleCloseClick: null,
};

const completeDialog = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      return { open: true, ...action.dialogData };
    case CLOSE:
      return Object.assign({}, state, { open: false });
    default:
      return state;
  }
};

export default completeDialog;



// WEBPACK FOOTER //
// ./src/redux/modules/completeDialog.js